import React, { useState } from "react";
import { CONTACT_INFO_TYPES } from "./contact_info_types";

// Row editor for a single contact info — the type it is and the value it holds. Both are editable on
// an existing row: a migrated row can carry the wrong type, and re-typing is cheaper than
// remove-then-add. The server owns per-type format validation (an email must parse as one, a Twitter
// value must be a handle), so failures come back through the modal's error alert rather than being
// second-guessed here.
function EditContactInfo({ contactInfo, onConfirm, onCancel, disabled = false }) {
  const [draft, setDraft] = useState({
    type: contactInfo.type || CONTACT_INFO_TYPES[0].value,
    value: contactInfo.value || "",
  });

  const handleChange = (field) => (value) => {
    setDraft((prev) => ({ ...prev, [field]: value }));
  };

  // An empty value is never a contact detail, and a mutation already in flight would be swallowed by
  // the single-flight hook, so neither can reach confirm.
  const confirmDisabled = disabled || draft.value.trim().length === 0;

  return (
    <tr>
      <td>
        <select
          aria-label="Contact type"
          className="form-select"
          value={draft.type}
          onChange={(e) => handleChange("type")(e.currentTarget.value)}
        >
          {CONTACT_INFO_TYPES.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </td>
      <td>
        <input
          aria-label="Contact value"
          className="form-control"
          value={draft.value}
          onChange={(e) => handleChange("value")(e.currentTarget.value)}
        />
      </td>
      <td className="text-nowrap">
        <div className="d-flex">
          <button
            onClick={() => onConfirm({ type: draft.type, value: draft.value.trim() })}
            type="button"
            className="btn btn-sm btn-outline-primary d-flex"
            aria-label="Confirm"
            disabled={confirmDisabled}
          >
            <i className="fas fa-check" />
          </button>
          &nbsp;
          <button
            onClick={onCancel}
            type="button"
            className="btn btn-sm btn-outline-secondary d-flex"
            aria-label="Cancel"
            disabled={disabled}
          >
            <i className="fas fa-xmark" />
          </button>
        </div>
      </td>
    </tr>
  );
}

export default EditContactInfo;
